<div class="container-fluid">
  <div class="row align-items-center justify-content-center">
                                <div class="col">
                                  <highcharts-chart [Highcharts]="highchartsPie"
                                                    [options]="chartOptions"
                                                    style="width:55vh ;height:50vh; display: block;">
                                  </highcharts-chart>


                                </div>
  </div>
  </div>
